
import { JStore } from '../journeys/context/interfaces';




const getObjectValFromString = (arrKeys: [], journeyStore: JStore) => {

	if (arrKeys && arrKeys.length > 0) {
		let tempStore: any = journeyStore;
		arrKeys.forEach((key) => {
			if (tempStore && typeof tempStore === 'object') {
				tempStore = tempStore[key];
			}
		});
		return tempStore;
	}

	return false;
}

export function getParsedValue(expression: any, journeyStore?: JStore) {
	if (expression) {
		const templateMatcher = /{{\s?([^{}\s]*)\s?}}/g;
		return expression.replace(templateMatcher, (substring: any, value: any, index: any) => {
			if (journeyStore && journeyStore[value]) {
				return journeyStore[value]
			}
			else if (journeyStore && value.includes(".")) {
				let parsedString = getObjectValFromString(value.split("."), journeyStore);
				if (parsedString)
					return parsedString;
			}
			return ``;

		})
	}
}